import { useEffect } from 'react';

import useLazyTimetableBannerNewsQuery from './useLazyTimetableBannerNewsQuery';

/**
 * @typedef {Object} TimetableBannerNewsQueryResult
 * @property {Object[]|undefined} timetableBannerNews - Array of timetable news items
 * @property {boolean|undefined} loading - Loading state
 * @property {boolean|undefined} called - Whether the query has been called
 * @property {Error|undefined} error - Error object
 */

/**
 * @typedef {('UK_EN'|'US_EN'|'FR_FR'|'BE_FR'|'BE_EN'|'BE_NL'|'NL_NL'|'DE_DE'|'RW_EN')} MarketEnum
 */

/**
 * @typedef {function} LazyTimetableBannerNewsQueryFunction
 * @param {Object} options
 * @param {MarketEnum} options.market - Market
 * @returns {void}
 */

/**
 * @typedef {[LazyTimetableBannerNewsQueryFunction, TimetableBannerNewsQueryResult]} LazyTimetableBannerNewsQueryResult
 */

/**
 * Hook to fetch timetable banner news
 * @param {Object} options
 * @param {MarketEnum} options.market - Market
 * @returns {TimetableBannerNewsQueryResult}
 */
const useTimetableBannerNewsQuery = ({ market }) => {
  const [timetableBannerNewsQuery, { timetableBannerNews, loading, called }] = useLazyTimetableBannerNewsQuery();

  useEffect(() => {
    if (called) {
      return;
    }

    timetableBannerNewsQuery({ market });
  }, [called, timetableBannerNewsQuery, market]);

  return { timetableBannerNews, loading };
};

export default useTimetableBannerNewsQuery;
